<template>
  <div>
    <div class="modal is-active" v-show="showEditModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Edit Timesheet</p>
          <button class="delete" aria-label="close" @click="cancel"></button>
        </header>
        <section class="modal-card-body">
          <span v-if="isFetchingId">
            <br />
            <b-loading :is-full-page="false" :active.sync="isFetchingId" :can-cancel="false"></b-loading>
            <br />
          </span>
          <span v-else>
            <div class="column">
              <b-field label="Date" custom-class="is-small">
                <input type="date" class="input is-small" v-model="timesheet.dateLog" />
              </b-field>
            </div>
            <div class="column">
              <b-field label="Check In" custom-class="is-small">
                <input type="time" v-model="timesheet.checkIn" class="input is-small" />
              </b-field>
            </div>
            <div class="column">
              <b-field label="Check Out" custom-class="is-small">
                <input type="time" v-model="timesheet.checkOut" class="input is-small" />
              </b-field>
            </div>
            <div class="column">
              <b-field label="Overtime In" custom-class="is-small">
                <input type="time" v-model="timesheet.overtimeIn" class="input is-small" />
              </b-field>
            </div>
            <div class="column">
              <b-field label="Overtime Out" custom-class="is-small">
                <input type="time" v-model="timesheet.overtimeOut" class="input is-small" />
              </b-field>
            </div>
          </span>
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="buttonEdit" @click="updateTimesheet">Update</button>
          <button class="button is-small" @click="cancel">Close</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import axios from 'axios'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    buttonEdit: appButton.isLoadingSuccess(false),
    timesheetForAttendanceLog: {},
    isFetchingId: false
  }),
  computed: {
    ...mapState('timesheet', {
      showEditModal: state => state.showEditModal,
      timesheet: state => state.timesheet
    })
  },
  methods: {
    ...mapActions('timesheet', ['openEditModal']),
    updateTimesheet() {
      const dateLog = this.timesheet.dateLog

      this.timesheetForAttendanceLog.checkInDateLog = `${dateLog} ${
        this.timesheet.checkIn
      }`
      this.timesheetForAttendanceLog.checkOutDateLog = `${dateLog} ${
        this.timesheet.checkOut
      }`
      this.timesheetForAttendanceLog.overtimeInDateLog = `${dateLog} ${
        this.timesheet.overtimeIn
      }`
      this.timesheetForAttendanceLog.overtimeOutDateLog = `${dateLog} ${
        this.timesheet.overtimeOut
      }`
      this.timesheetForAttendanceLog.employeeIdNumber = this.timesheet.employeeId
      axios
        .put(
          `api/attendancelog/update-attendance-log`,
          this.timesheetForAttendanceLog
        )
        .then(response => {
          appToast.success(response.data)
          this.openEditModal({
            showEditModal: false
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    cancel() {
      this.openEditModal({
        showEditModal: false
      })
    }
  },
  watch: {
    timesheet() {
      if (this.timesheet) {
        this.isFetchingId = true
        const query = {
          checkInDateLog: `${this.timesheet.dateLog} ${this.timesheet.checkIn}`,
          checkOutDateLog: `${this.timesheet.dateLog} ${
            this.timesheet.checkOut
          }`,
          overtimeInDateLog: `${this.timesheet.dateLog} ${
            this.timesheet.overtimeIn
          }`,
          overtimeOutDateLog: `${this.timesheet.dateLog} ${
            this.timesheet.overtimeOut
          }`,
          employeeIdNumber: this.timesheet.employeeId
        }
        axios
          .post(`api/attendancelog/by-datelog-and-employeeidnum`, query)
          .then(response => {
            this.timesheetForAttendanceLog.checkInId = response.data.checkInId
            this.timesheetForAttendanceLog.checkOutId = response.data.checkOutId
            this.timesheetForAttendanceLog.overtimeInId =
              response.data.overtimeInId
            this.timesheetForAttendanceLog.overtimeOutId =
              response.data.overtimeOutId

              this.isFetchingId = false
          })
          .catch(error => {
            console.log(error)
            this.isFetchingId = false
          })
          .then(() => {
            this.isFetchingId = false
          })
      }
    }
  }
}
</script>
